// src/pages/Enseignants/PassagesGrades/components/GradeGroupHeader.jsx

import React from "react";
import { FaLayerGroup } from "react-icons/fa";

const GradeGroupHeader = ({ groupName, count, stats }) => {
  return (
    <div className="flex flex-col gap-3 rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/60 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-slate-900 text-white dark:bg-white dark:text-slate-950">
          <FaLayerGroup />
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Groupe sélectionné
          </p>
          <h2 className="text-lg font-bold text-slate-900 dark:text-white">
            {groupName}
          </h2>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        <span className="rounded-full bg-slate-900 px-3 py-1 text-xs font-bold text-white dark:bg-white dark:text-slate-950">
          {count} adhérent{count > 1 ? "s" : ""}
        </span>

        <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300">
          {stats?.graded || 0} noté{(stats?.graded || 0) > 1 ? "s" : ""}
        </span>

        <span className="rounded-full bg-amber-50 px-3 py-1 text-xs font-bold text-amber-700 dark:bg-amber-500/10 dark:text-amber-300">
          {stats?.notGraded || 0} à noter
        </span>
      </div>
    </div>
  );
};

export default GradeGroupHeader;